// ModalUploadProvider.jsx
import React, { useState } from "react";
import { Modal, Button, Icon, Form } from "semantic-ui-react";
import { BillingsAPI } from "../../../api/billingsAPI";
import { useAuth } from "../../../hooks";

const billingController = new BillingsAPI();

/**
 * Muestra un modal para subir (o reemplazar) la Factura Proveedor (billingdatapartner).
 */
export function ModalUploadProvider(props) {
  const { show, onClose, billing } = props;
  const { accessToken } = useAuth();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // Manejo de la selección de archivo
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  // Subir el archivo
  const handleSubmit = async () => {
    if (!file) {
      alert("Debes seleccionar un archivo");
      return;
    }
    try {
      setLoading(true);
      // Asumimos que tu BillingsAPI tiene un método updateBillingFile 
      // para subir la Factura Proveedor => isClient=false
      await billingController.updateBillingFile(accessToken, billing._id, false, file);
      setFile(null);
      onClose(); // cierra el modal
      //window.location.reload(); // o algún callback para refrescar la lista
    } catch (error) {
      console.error("Error subiendo Factura Proveedor:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={show} onClose={onClose} size="tiny">
      <Modal.Header>Subir Factura Proveedor</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>Selecciona archivo (PDF o imagen)</label>
            <input 
              type="file" 
              accept="application/pdf,image/*" 
              onChange={handleFileChange}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} disabled={loading}>
          <Icon name="cancel" /> Cancelar
        </Button>
        <Button primary loading={loading} onClick={handleSubmit}>
          <Icon name="upload" /> Subir
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
